// @ts-nocheck

import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createSpecialOffer } from "../../../features/specialOffers";
import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";
const AddSpecialOffer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "", // Special offer name
    descriptions: [""], // Description of the special offer
    price: "", // Price of the special offer
    photo: null, // Image for the special offer
  });

  const [imagePreview, setImagePreview] = useState(null); // For image preview

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDescription = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,index:number) => {
    const {  value } = e.target;
    setFormData((prev) => ({
      ...prev,
      descriptions: prev.descriptions.map((desc, i) =>
        i === index ? value : desc // Update the value at the specific index
      ),
    }));
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        photo: e.target.files[0], // Handle photo image change
      }));
      setImagePreview(URL.createObjectURL(e.target.files[0])); // For image preview
    }
  };

  const handleSubmit = () => {
    // Dispatch createSpecialOffer with formData
    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (key === "descriptions" && Array.isArray(value)) {
        value.forEach((desc, index) => {
          formDataFinal.append(`descriptions`, desc); // Adds descriptions[0], descriptions[1], etc.
        });
      } else if (value !== undefined && value !== null) {
        formDataFinal.append(key, value);
      }
    });

    dispatch(createSpecialOffer(formDataFinal))
      .then((res) => {
        toast.success(res.payload.message); // Assuming you have a toast function
        navigate('/special-offer'); // Redirect to special offer list or another page
      })
      .catch((err) => {
        console.log(err, "error");
        toast.error("An error occurred while creating the special offer.");
      });
  };

  const handleAddDescription = () => {
    console.log("hiii");
    
    setFormData({
      ...formData,
      descriptions: [...formData.descriptions, ""], // Create a new array with the added description
    });
  }

  const handleRemoveDescription = (id:any) => {
    setFormData({
      ...formData,
      descriptions: formData.descriptions.filter((_,index)=>id !== index), // Create a new array with the added description
    });
  }
  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
      <SoftBox width="100%" maxWidth="400px">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Add Special Offer
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Name
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="name"
              placeholder="Enter the offer name"
              value={formData.name}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Description
              </SoftTypography>
            </SoftBox>
            {
formData.descriptions.map((description:any,index:number)=>
<>
<SoftBox display="flex">
  <SoftInput
  style={{ marginTop: '5px' }}
    type="text"
    name="description"
    placeholder="Enter the offer description"
    value={formData.description}
    onChange={(e)=>handleChangeDescription(e,index)}
  />
  {

 index === 0 && <FaCirclePlus style={{ marginLeft: '5px' }} onClick={handleAddDescription}  />
  }

{

index !== 0 && <FaCircleMinus style={{ marginLeft: '5px' }} onClick={()=>handleRemoveDescription(index)}  />
 }
  </SoftBox>
</>
)
            }
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Price
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="number"
              name="price"
              placeholder="Enter the price"
              value={formData.price}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Photo
              </SoftTypography>
            </SoftBox>
            <input
              type="file"
              accept="image/*"
              name="photo"
              onChange={handleImageChange}
              style={{ width: "100%" }}
            />
            {imagePreview && (
              <img src={imagePreview} alt="Preview" style={{ width: "150px", height: "150px", marginTop: "20px" }} />
            )}
          </SoftBox>

          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddSpecialOffer;
